<template>
  <div>
    <!-- 创建集群环境按钮 -->
    <el-button class="base-margin__bottom-10" type="primary" @click="createClusterEnv">
      {{ $t('computingCluster.clusterEnv.createClusterEnv') }}
    </el-button>

    <!-- 集群环境表格 -->
    <div class="table">
      <el-table v-loading="tableLoading" :data="tableData" class="table_width">
        <el-table-column :label="$t('computingCluster.clusterEnv.id')" prop="id" width="100"></el-table-column>
        <el-table-column :label="$t('computingCluster.clusterEnv.name')" prop="name" width="200"></el-table-column>
        <el-table-column :label="$t('computingCluster.clusterEnv.region')" width="80">
          <template slot-scope="scope">
            <span>{{ filterRegionList(scope.row.region) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('computingCluster.clusterEnv.cosBucket')" width="400">
          <template slot-scope="scope">
            <span v-if="scope.row.cosBucket !== ''"
              >{{ scope.row.cosBucket }}({{ filterRegionList(scope.row.cosRegion) }})</span
            >
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('computingCluster.clusterEnv.fileStorage')">
          <template slot-scope="scope">
            <div v-if="scope.row.cfsId">
              <span>{{ scope.row.cfsId }}</span>
              <span>({{ filterRegionList(scope.row.cfsRegion) }})</span>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('computingCluster.clusterEnv.cfsSecurityGroup')"
          prop="cfsGroupId"
        ></el-table-column>
        <el-table-column :label="$t('computingCluster.clusterEnv.vpc')" prop="vpcId"></el-table-column>
        <el-table-column :label="$t('computingCluster.clusterEnv.subnetId')" prop="subnetId"></el-table-column>
        <el-table-column :label="$t('computingCluster.clusterEnv.createTime')" prop="createTime"></el-table-column>
        <el-table-column :label="$t('computingCluster.clusterEnv.actions')" width="400">
          <template slot-scope="scope">
            <el-button type="text" @click="editEnv(scope.row)">{{ $t('computingCluster.clusterEnv.edit') }}</el-button>
            <el-button type="text" @click="clearEnv(scope.row)"
              >{{ $t('computingCluster.clusterEnv.clear') }}
            </el-button>
            <el-button type="text" @click="deleteEnv(scope.row.id)"
              >{{ $t('computingCluster.clusterEnv.delete') }}
            </el-button>
            <el-button type="text" @click="getHostNameManageList(scope.row, '')"> hostname管理 </el-button>
            <el-button type="text" @click="getQueueManageList(scope.row, 'get')"> 弹性队列管理 </el-button>
            <el-button type="text" @click="openTemplateManagementDrawer(scope.row)"> 模板管理 </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页器 -->
      <el-pagination
        :page-size="10"
        :page-sizes="[10, 20, 50, 100]"
        :total="tableDataTotal"
        align="right"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="onCurrentChange"
      >
      </el-pagination>
    </div>

    <!-- 创建/编辑集群环境对话框 -->
    <el-dialog :close-on-click-modal="false" :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
      <el-form ref="formLabelAlign" label-position="left" :model="formLabelAlign" :rules="rules" label-width="150px">
        <el-form-item :label="$t('computingCluster.clusterEnv.name')" prop="name">
          <el-input v-model="formLabelAlign.name" :placeholder="$t('computingCluster.clusterEnv.inputName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('computingCluster.clusterEnv.region')" prop="region">
          <el-select
            v-model="formLabelAlign.region"
            :placeholder="$t('computingCluster.clusterEnv.selectRegion')"
            @change="changeRegion"
          >
            <el-option v-for="item in regionData" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('computingCluster.clusterEnv.privateNetwork')"
          class="select-width"
          filterable
          prop="vpcId"
        >
          <div class="base-flex">
            <el-select
              v-model="formLabelAlign.vpcId"
              :placeholder="$t('computingCluster.clusterEnv.selectPrivateNetwork')"
              clearable
              @change="changeVpcZone"
            >
              <el-option
                v-for="item in vpcList"
                :key="item.VpcId"
                :label="`${item.VpcName} | ${item.VpcId} | ${item.CidrBlock}`"
                :value="item.VpcId"
              ></el-option>
            </el-select>
            <el-button
              :disabled="formLabelAlign.region === '' || createVpcLoading"
              :icon="createVpcLoading ? 'el-icon-loading' : ''"
              class="base-margin__left-10"
              type="primary"
              @click="createVpc"
            >
              {{ $t('computingCluster.clusterEnv.createNow') }}
            </el-button>
          </div>
        </el-form-item>

        <el-form-item :label="$t('computingCluster.clusterEnv.subnetInfo')">
          <div class="base-flex">
            <el-form-item class="base-margin__right-10" prop="zone">
              <el-select
                v-model="formLabelAlign.zone"
                :placeholder="$t('computingCluster.clusterEnv.selectRegion')"
                class="base-margin__right-10"
                clearable
                @change="changeVpcZone"
              >
                <el-option v-for="item in zones" :key="item.ZoneId" :label="item.ZoneName" :value="item.Zone"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="subnetId">
              <el-select
                v-model="formLabelAlign.subnetId"
                :placeholder="$t('computingCluster.clusterEnv.selectSubnetInfo')"
                clearable
                filterable
              >
                <el-option
                  v-for="item in subnetList"
                  :key="item.SubnetId"
                  :label="`${item.SubnetId} | ${item.SubnetName} | ${item.CidrBlock}`"
                  :value="item.SubnetId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form-item>

        <el-form-item :label="$t('computingCluster.clusterEnv.scheduler')" prop="workloadManager">
          <el-select
            v-model="formLabelAlign.workloadManager"
            :placeholder="$t('computingCluster.clusterEnv.selectScheduler')"
            class="select-width"
          >
            <el-option
              v-for="item in workloadManagerList"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('computingCluster.clusterEnv.securityGroup')">
          <el-select
            v-model="formLabelAlign.securityGroupId"
            :placeholder="$t('computingCluster.clusterEnv.selectSecurityGroup')"
            class="base-margin__right-10"
            clearable
          >
            <el-option
              v-for="item in securityGroupOption"
              :key="item.SecurityGroupId"
              :label="`${item.SecurityGroupName} | ${item.SecurityGroupId}`"
              :value="item.SecurityGroupId"
            >
              <span>{{ item.SecurityGroupName }} | {{ item.SecurityGroupId }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('computingCluster.clusterEnv.cfsSecurityGroup')">
          <el-select
            v-model="formLabelAlign.cfsGroupId"
            :placeholder="$t('computingCluster.clusterEnv.selectCFSSecurityGroup')"
            class="base-margin__right-10"
            clearable
          >
            <el-option
              v-for="item in cfsGroupOption"
              :key="item.PGroupId"
              :label="item.Name"
              :value="item.PGroupId"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('computingCluster.clusterEnv.fileStorage')">
          <div class="base-flex">
            <el-form-item class="base-margin__right-10" prop="cfsRegion">
              <el-select
                v-model="formLabelAlign.cfsRegion"
                :placeholder="$t('computingCluster.clusterEnv.selectFileStorageRegion')"
              >
                <el-option v-for="item in regionData" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="cfsId">
              <el-input
                v-model="formLabelAlign.cfsId"
                :placeholder="$t('computingCluster.clusterEnv.inputFileStorageId')"
                style="width: 230px"
                @input="changeCFSID"
              ></el-input>
            </el-form-item>
          </div>
        </el-form-item>

        <el-form-item :label="$t('computingCluster.clusterEnv.fileStorageType')">
          <el-select
            v-model="formLabelAlign.cfsStorageType"
            :disabled="formLabelAlign.cfsId !== ''"
            :placeholder="$t('computingCluster.clusterEnv.selectFileStorageType')"
            class="base-margin__right-10"
          >
            <el-option
              v-for="item in cfsStorageTypeList"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('computingCluster.clusterEnv.objectStorage')">
          <div class="base-flex">
            <el-form-item class="base-margin__right-10" prop="cosRegion">
              <el-select
                v-model="formLabelAlign.cosRegion"
                :placeholder="$t('computingCluster.clusterEnv.cosRegion')"
                class="base-margin__right-10"
              >
                <el-option v-for="item in regionData" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="cosBucket">
              <el-input
                v-model="formLabelAlign.cosBucket"
                :placeholder="$t('computingCluster.clusterEnv.selectCosBucket')"
                style="width: 230px"
              ></el-input>
            </el-form-item>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="createLoading" type="primary" @click="createCode">
          {{ $t('computingCluster.clusterEnv.confirm') }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 计算集群所有环境弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :title="$t('computingCluster.clusterEnv.allClusterEnvironments')"
      :visible.sync="projectEnvDialogVisible"
      class="projectEnvInfo"
      width="650px"
    >
      <div v-loading="projectEnvLoading">
        <el-form label-width="160px">
          <el-form-item :label="$t('computingCluster.clusterEnv.cosBucket') + '：'">
            <div class="base-flex__between">
              <span>{{ clusterForm.cosBucket || '-' }}</span>
              <span>
                <el-button
                  :disabled="clusterForm.cosBucket === ''"
                  type="text"
                  @click="clearResource('cos', 'cosBucket', clusterForm.id, 'cos:DeleteBucket ')"
                >
                  {{ $t('computingCluster.clusterEnv.clearResource') }}
                </el-button>
              </span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('computingCluster.clusterEnv.cfs') + '：'">
            <div class="base-flex__between">
              <span>{{ clusterForm.cfsId || '-' }}</span>
              <span>
                <el-button
                  :disabled="clusterForm.cfsId === ''"
                  type="text"
                  @click="clearResource('cfs', 'cfsId', clusterForm.id, 'cfs:DeleteCfsFileSystem')"
                >
                  {{ $t('computingCluster.clusterEnv.clearResource') }}
                </el-button>
              </span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('computingCluster.clusterEnv.cfsSecurityGroup') + '：'">
            <div class="base-flex__between">
              <span>{{ clusterForm.cfsGroupId || '-' }}</span>
              <span>
                <el-button
                  :disabled="clusterForm.cfsGroupId === ''"
                  type="text"
                  @click="clearResource('cfsSecurityGroup', 'cfsGroupId', clusterForm.id, 'cfs:DeleteCfsPGroup')"
                >
                  {{ $t('computingCluster.clusterEnv.clearResource') }}
                </el-button>
              </span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('computingCluster.clusterEnv.securityGroup') + '：'">
            <div class="base-flex__between">
              <span
                >{{ clusterForm.securityGroupId || '-' }} |
                {{ clusterForm.securityGroupId !== '' ? clusterForm.securityGroupName : '-' }}</span
              >
              <span>
                <el-button
                  :disabled="clusterForm.securityGroupId === ''"
                  type="text"
                  @click="clearResource('securityGroup', 'securityGroupId', clusterForm.id, 'vpc:DeleteSecurityGroup')"
                >
                  {{ $t('computingCluster.clusterEnv.clearResource') }}
                </el-button>
              </span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('computingCluster.clusterEnv.vpc') + '：'">
            <div class="base-flex__between">
              <span>{{ clusterForm.vpcId || '-' }} | {{ clusterForm.vpcId !== '' ? clusterForm.vpcName : '-' }}</span>
              <span>
                <el-button
                  :disabled="clusterForm.vpcId === ''"
                  type="text"
                  @click="clearResource('vpc', 'vpcId', clusterForm.id, 'vpc:DeleteVpc')"
                >
                  {{ $t('computingCluster.clusterEnv.clearResource') }}
                </el-button>
              </span>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!--Host-Name管理-->
    <el-drawer
      title="Host-Name管理"
      size="940px"
      :visible.sync="hostsRangeDrawerVisible"
      @close="closeHostsRangeDialog"
    >
      <div class="base-margin__left-20">
        <el-button class="base-margin__bottom-20" type="primary" @click="openHostsRangeForm({})"
          >新增Host-Name管理</el-button
        >
        <el-table :data="hostRangeList">
          <el-table-column prop="id" label="ID" width="50"></el-table-column>
          <el-table-column prop="name" label="Name"></el-table-column>
          <el-table-column
            :label="$t('customCluster.previewIp.hostnamePrefix')"
            prop="hostnamePattern"
          ></el-table-column>
          <el-table-column :label="$t('customCluster.previewIp.startIndex')" prop="indexStart"></el-table-column>
          <el-table-column :label="$t('customCluster.previewIp.endIndex')" prop="indexEnd"></el-table-column>
          <el-table-column :label="$t('customCluster.previewIp.indexDigits')" prop="indexLength"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openHostsRangeForm(scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="deleteHostsRange(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>

    <!--编辑Host-Name管理-->
    <el-dialog
      title="Host-Name管理"
      :visible.sync="hostsRangeDialogVisible"
      :close-on-click-modal="false"
      width="500px"
      @close="closeHostsRangeDialog"
    >
      <div>
        <el-form ref="hostsRangeForm" :model="hostsRangeForm" label-width="100px">
          <el-form-item :label="$t('computingCluster.clusterEnv.name')">
            <el-input
              :placeholder="$t('computingCluster.clusterEnv.inputName')"
              v-model="hostsRangeForm.name"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('customCluster.createCluster.label.hostnamePrefix')">
            <el-input
              :placeholder="$t('customCluster.previewIp.enterHostname')"
              v-model="hostsRangeForm.hostnamePattern"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('customCluster.previewIp.startIndex')">
            <el-input-number
              :placeholder="$t('customCluster.previewIp.selectStartIndex')"
              :max="500"
              :min="0"
              v-model="hostsRangeForm.indexStart"
            ></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('customCluster.previewIp.endIndex')">
            <el-input-number
              :placeholder="$t('customCluster.previewIp.selectEndIndex')"
              :max="500"
              :min="0"
              v-model="hostsRangeForm.indexEnd"
            ></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('customCluster.previewIp.indexDigits')">
            <el-input
              :placeholder="$t('customCluster.previewIp.selectIndexDigits')"
              v-model="hostsRangeForm.indexLength"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hostsRangeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setHostsRange">确 定</el-button>
      </span>
    </el-dialog>

    <!--弹性队列管理-->
    <el-drawer title="弹性队列管理" size="920px" :visible.sync="queueManageDrawerVisible" @close="closeQueueManageDialog">
      <div class="base-margin__left-20">
        <el-button class="base-margin__bottom-20" type="primary" @click="openQueueManageForm({})"
          >新增队列管理</el-button
        >
        <el-table :data="queueManageList">
          <el-table-column prop="id" label="ID" width="50"></el-table-column>
          <el-table-column prop="name" label="Name"></el-table-column>
          <el-table-column label="项目ID" prop="projectId"></el-table-column>
          <el-table-column label="hostName管理" prop="rangeId">
            <template slot-scope="scope">
              {{ filterQueueManageList(scope.row.rangeId, hostRangeList) }}
            </template>
          </el-table-column>
          <el-table-column label="模板">
            <template slot-scope="scope">
              {{ filterQueueManageList(scope.row.templateId, templateList) }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('computingCluster.resource.createTime')"
            width="180"
            prop="createTime"
          ></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openQueueManageForm(scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="deleteQueueManage(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>

    <!--队列管理-->
    <el-dialog
      title="队列管理"
      :visible.sync="queueManageDialogVisible"
      :close-on-click-modal="false"
      width="500px"
      @close="closeQueueManageDialog"
    >
      <div>
        <el-form ref="queueManageForm" :model="queueManageForm" label-position="left" label-width="124px">
          <el-form-item label="队列名称">
            <el-input placeholder="请输入队列名称" v-model="queueManageForm.name"></el-input>
          </el-form-item>
          <el-form-item label="hostName">
            <el-select v-model="queueManageForm.rangeId" placeholder="请选择hostName管理">
              <el-option v-for="item in hostRangeList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模板">
            <el-select v-model="queueManageForm.templateId" placeholder="请选择模板">
              <el-option v-for="item in templateList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="挂起等待时间">
              <el-input-number v-model="queueManageForm.suspendTime" :min="1" label="请输入挂起等待时间"></el-input-number>  秒
          </el-form-item>
          <el-form-item label="创建节点超时时间">
              <el-input-number v-model="queueManageForm.resumeTimeout" :min="1" label="请输入创建节点超时时间"></el-input-number> 秒
          </el-form-item>
          <el-form-item label="销毁节点超时时间">
              <el-input-number v-model="queueManageForm.suspendTimeout" :min="1" label="请输入销毁节点超时时间"></el-input-number> 秒
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="queueManageDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setQueueManage">确 定</el-button>
      </span>
    </el-dialog>

    <!--模板管理-->
    <el-drawer
      title="模板管理"
      size="80%"
      :visible.sync="templateManagementDrawerVisible"
      @close="closeTemplateManagementDrawer"
      append-to-body
    >
      <div class="base-margin__left-20 base-margin__right-20 base-height_fullscreen">
        <TemplateManage />
      </div>
    </el-drawer>
    <ExamineAKSK :examineAKSKVisible="examineAKSKVisible" :examineAKSKVisibleFalse="examineAKSKVisibleFalse" />
  </div>
</template>

<script>
import { getRequest, postRequest } from '@/common/libs/request';
import { Message } from 'element-ui';
import { cfsStorageTypeList, debounce, filterRegionList, regionList, workloadManagerList } from '@/common/utils/utils';
import { use } from '@tencent/tea-sdk-runner';
import { mapGetters, mapState } from 'vuex';
import ExamineAKSK from '@/components/examineAKSK/index.vue';
import { setupMfaSdk } from '@/common/libs/setupMfaSdk';
import TemplateManage from '@/views/computingCluster/components/templateManagement/IndexView.vue';

export default {
  name: 'mirrorManagement',
  components: {
    ExamineAKSK,
    TemplateManage,
  },
  data() {
    return {
      tableData: [], // 镜像列表
      dialogVisible: false,
      loginType: 'qq', // 登录类型
      regionData: regionList,
      // 调度器list 工作负载管理器 0=slurm22.05 1=IBM Spectrum LSF Community Edition 10.1 2=IBM Spectrum LSF 10.1.0
      workloadManagerList,
      formLabelAlign: {
        name: '',
        region: '',
        vpcId: '',
        cfsId: '',
        cfsRegion: '',
        cosBucket: '',
        cfsStorageType: '',
        workloadManager: '',
        cosRegion: '',
        subnetId: '',
        zone: '',
        securityGroupId: '',
        cfsGroupId: '',
      },
      dialogTitle: this.$t('computingCluster.clusterEnv.createClusterEnv'),
      dialogType: 'add',
      pageIndex: 1, // 分页index
      pageLimit: 10, // 每一页条数
      tableDataTotal: 0, // 任务总数
      tableLoading: false,
      cfsStorageTypeList,
      vpcList: [],
      createLoading: false,
      clusterForm: {},
      projectEnvDialogVisible: false,
      projectEnvLoading: false,
      rules: {
        name: [
          { required: true, message: this.$t('computingCluster.clusterEnv.inputNameRequired'), trigger: 'change' },
        ],
        region: [
          { required: true, message: this.$t('computingCluster.clusterEnv.selectRegionRequired'), trigger: 'change' },
        ],
        vpcId: [
          {
            required: true,
            message: this.$t('computingCluster.clusterEnv.selectPrivateNetworkRequired'),
            trigger: 'change',
          },
        ],
        workloadManager: [
          {
            required: true,
            message: this.$t('computingCluster.clusterEnv.selectSchedulerRequired'),
            trigger: 'change',
          },
        ],
      },
      filterRegionList,
      projectId: 0,
      examineAKSKVisible: false,
      currentProject: null,
      zones: [],
      subnetList: [],
      createVpcLoading: false,
      securityGroupOption: [],
      cfsGroupOption: [],
      hostsRangeDrawerVisible: false,
      hostsRangeDialogVisible: false,
      hostsRangeForm: {
        name: '',
        hostnamePattern: '',
        indexStart: 0,
        indexEnd: 30,
        indexLength: 3,
        envId: 0,
      },
      queueManageDrawerVisible: false,
      queueManageDialogVisible: false,
      queueManageList: [],
      hostRangeList: [],
      templateList: [],
      queueManageForm: {
        envId: 0,
        name: '',
        rangeId: '',
        templateId: '',
        suspendTime: 60,
        resumeTimeout: 120,
        suspendTimeout: 120,
      },
      templateManagementDrawerVisible: false,
    };
  },
  async created() {
    this.loginType = window.sessionStorage.getItem('loginType');
    // 如果是腾讯云用户
    if (this.loginType === 'cloud') {
      await setupMfaSdk();
    }
    this.getList();
  },
  mounted() {
    const currentProject = this.getCurrentProject() || {};
    this.projectId = currentProject.id;
    this.currentProject = currentProject;
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  watch: {
    'app.currentProject'(val) {
      const currentProject = this.getCurrentProject();
      this.currentProject = currentProject;
      if (currentProject.id !== this.projectId) {
        this.projectId = val.id;
        this.getList();
      }
    },
  },

  methods: {
    /**
     * 打开模板管理抽屉
     */
    openTemplateManagementDrawer() {
      this.templateManagementDrawerVisible = true;
    },

    /**
     * 关闭模板管理抽屉
     */
    closeTemplateManagementDrawer() {
      this.templateManagementDrawerVisible = false;
    },

    /**
     * 当CFS ID变化时的处理函数
     * @param {string} item - 新的CFS ID值
     */
    changeCFSID(item) {
      if (item !== '') {
        this.formLabelAlign.cfsStorageType = '';
      }
    },

    /**
     * 删除集群环境
     * @param {number} id - 要删除的环境ID
     * 1. 显示确认对话框
     * 2. 发送删除请求
     * 3. 处理删除结果
     */
    deleteEnv(id) {
      this.$confirm(
        this.$t('computingCluster.clusterEnv.deleteConfirm'),
        this.$t('computingCluster.clusterEnv.deleteTitle'),
        {
          confirmButtonText: this.$t('computingCluster.clusterEnv.confirm'),
          cancelButtonText: this.$t('computingCluster.clusterEnv.cancel'),
        },
      )
        .then(() => {
          this.tableLoading = true;
          postRequest('/api/eda/common/project/deleteProjectEnv', { id })
            .then(() => {
              Message.success(this.$t('computingCluster.clusterEnv.deleteSuccess'));
              this.tableLoading = false;
              this.getList();
            })
            .catch(() => {
              this.tableLoading = false;
            });
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },

    /**
     * 清空集群资源
     * @param {string} type - 资源类型
     * @param {string} editType - 编辑类型
     * @param {number} id - 环境ID
     * @param {string} mfaType - MFA认证类型
     * 1. 检查登录类型
     * 2. 执行MFA认证(腾讯云用户)
     * 3. 调用清空资源方法
     */
    async clearResource(type, editType, id, mfaType) {
      if (this.loginType === 'qq') {
        this.clearData(type, editType, id);
      } else {
        try {
          if (!this.mfaSdk) {
            this.mfaSdk = await use('mfa-sdk');
          }
          this.mfaSdk
            .verify({ api: mfaType })
            .then(() => {
              this.clearData(type, editType, id);
            })
            .catch((e) => {
              console.log(333, e, e.innerError);
              this.projectEnvLoading = false;
            });
        } catch (e) {
          this.$message.error(this.$t('computingCluster.clusterEnv.mfaFailed'));
          this.projectEnvLoading = false;
        }
      }
    },

    /**
     * 删除集群资源数据
     * @param {string} type - 资源类型
     * @param {string} editType - 编辑类型
     * @param {number} envId - 环境ID
     * 1. 显示确认对话框
     * 2. 发送清空资源请求
     * 3. 更新表单数据
     */
    clearData(type, editType, envId) {
      this.$confirm(
        this.$t('computingCluster.clusterEnv.deleteResourceConfirm'),
        this.$t('computingCluster.clusterEnv.deleteResourceTitle'),
        {
          confirmButtonText: this.$t('computingCluster.clusterEnv.confirm'),
          cancelButtonText: this.$t('common.cancel'),
        },
      ).then(() => {
        this.projectEnvLoading = true;
        postRequest('/api/eda/common/project/clearResource', { name: type, envId })
          .then(() => {
            this.clusterForm[editType] = '';
            if (editType === 'vpcId') {
              this.clusterForm.subnetId = '';
              this.clusterForm.zone = '';
            }
            Message.success(this.$t('computingCluster.clusterEnv.deleteSuccess'));
            this.projectEnvLoading = false;
          })
          .catch(() => {
            this.projectEnvLoading = false;
          });
      });
    },

    /**
     * 获取VPC列表
     * @param {string} newVal - 新选择的区域值
     * 1. 重置VPC相关表单字段
     * 2. 获取安全组信息
     * 3. 获取VPC列表
     * 4. 获取可用区信息
     */
    changeRegion(newVal = '') {
      this.vpcList = [];
      if (this.dialogType === 'add' || newVal !== '') {
        this.formLabelAlign.vpcId = '';
        this.formLabelAlign.zone = '';
        this.formLabelAlign.subnetId = '';
        this.formLabelAlign.securityGroupId = '';
        this.formLabelAlign.cfsId = '';
        this.formLabelAlign.cfsRegion = this.formLabelAlign.region;
      }
      if (this.formLabelAlign.region === '') {
        return;
      }
      this.getSecurityGroup();
      getRequest(`/api/eda/common/tencentcloud/describeVpcList?region=${this.formLabelAlign.region}`)
        .then((res) => {
          this.vpcList = res.vpcSet;
          this.getZones();
        })
        .catch(() => {
          this.$message.error(this.$t('computingCluster.clusterEnv.getVpcFailed'));
        });
    },

    /**
     * 获取安全组信息
     * 1. 获取安全组列表
     * 2. 获取CFS安全组列表
     */
    getSecurityGroup() {
      this.securityGroupOption = [];
      this.cfsGroupOption = [];
      // 获取安全组
      postRequest('/api/eda/common/tencentcloud/describeSecurityGroupList', {
        region: this.formLabelAlign.region,
      }).then((res) => {
        this.securityGroupOption = res.securityGroup;
      });
      // cfs 安全组
      postRequest('/api/eda/common/project/describeCfsPGroups', {
        region: this.formLabelAlign.region,
      }).then((res) => {
        this.cfsGroupOption = res.list;
      });
    },

    /**
     * 打开创建/编辑对话框
     * 初始化表单数据并显示对话框
     */
    openDialog() {
      this.dialogType = 'add';
      this.dialogTitle = this.$t('computingCluster.clusterEnv.createClusterEnv');
      this.formLabelAlign = {
        name: '',
        region: '',
        vpcId: '',
        cfsId: '',
        cfsRegion: '',
        cosBucket: '',
        cfsStorageType: '',
        workloadManager: '',
        cosRegion: '',
        subnetId: '',
        zone: '',
        securityGroupId: '',
        cfsGroupId: '',
      };
      this.vpcList = [];
      this.zones = [];
      this.subnetList = [];
      this.createLoading = false;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formLabelAlign.clearValidate();
      });
    },

    /**
     * 主机名管理
     */
    getHostNameManageList(item, type) {
      const params = {
        envId: item.id,
        nodeType: 'queue',
      };
      this.hostsRangeForm.envId = item.id;
      postRequest('/api/eda/common/cluster/describeHostsRange', params).then((res) => {
        this.hostRangeList = res?.hostsRange || [];
        if (type === '') {
          this.hostsRangeDrawerVisible = true;
        }
      });
    },

    /**
     * 打开主机名管理
     */
    openHostsRangeForm(item) {
      this.hostsRangeForm = {
        ...this.hostsRangeForm,
        ...item,
        envId: this.hostsRangeForm.envId,
        nodeType: 'queue',
      };
      this.hostsRangeDialogVisible = true;
    },

    /**
     * 删除主机名管理
     */
    deleteHostsRange(item) {
      this.$confirm('删除Host-Name管理后，无法恢复，请确认是否删除？', this.$t('computingCluster.clusterEnv.delete'), {
        type: 'warning',
      })
        .then(() => {
          postRequest('/api/eda/common/cluster/delHostsRange', {
            id: item.id,
          }).then(() => {
            this.$message.success(this.$t('computingCluster.clusterEnv.deleteSuccess'));
            this.getHostNameManageList({ id: this.hostsRangeForm.envId, type: '' });
          });
        })
        .catch(() => {
          this.$message.info(this.$t('logManagement.cancelDelete'));
        });
    },

    /**
     * 關閉主机名管理
     */
    closeHostsRangeDialog() {
      const { envId } = this.hostsRangeForm;
      this.hostsRangeForm = {
        hostnamePattern: '',
        indexStart: 0,
        indexEnd: 30,
        indexLength: 3,
        envId,
        name: '',
      };
    },

    /**
     * 主机名管理
     */
    setHostsRange() {
      const params = {
        envId: this.hostsRangeForm.envId,
        nodeType: 'queue',
        hostRange: {
          ...this.hostsRangeForm,
          indexLength: +this.hostsRangeForm.indexLength,
        },
      };
      postRequest('/api/eda/common/cluster/setHostsRange', params).then(() => {
        this.$message.success('HostName管理设置成功');
        this.getHostNameManageList({ id: this.hostsRangeForm.envId, type: '' });
        this.hostsRangeDialogVisible = false;
      });
    },

    /**
     * 队列管理
     */
    getQueueManageList(item, type) {
      this.queueManageForm.envId = item.id;
      if (type === 'get') {
        this.getHostNameManageList({ id: item.id, type: 'queue' });
        this.getTemplateList(item.region);
      }
      // 队列list
      postRequest('/api/eda/common/cluster/describeAutoScalingQueueList', { envId: item.id }).then((res) => {
        this.queueManageList = res?.list || [];
        this.queueManageDrawerVisible = true;
      });
    },

    getTemplateList(region) {
      const params = {
        region,
        offset: 0,
        limit: 1000,
      };
      postRequest('/api/eda/common/cluster/describeTemplateList', params).then((res) => {
        this.templateList = res?.list || [];
      });
    },

    /**
     * 新增 编辑 队列管理
     */
    openQueueManageForm(item) {
      this.queueManageForm = {
        ...this.queueManageForm,
        ...item,
        envId: this.queueManageForm.envId,
      };
      this.queueManageDialogVisible = true;
    },

    /**
     * 删除 队列管理
     */
    deleteQueueManage(item) {
      this.$confirm('删除队列管理后，无法恢复，请确认是否删除？', this.$t('computingCluster.clusterEnv.delete'), {
        type: 'warning',
      })
        .then(() => {
          postRequest('/api/eda/common/cluster/delAutoScalingQueue', {
            id: item.id,
          }).then(() => {
            this.$message.success(this.$t('computingCluster.clusterEnv.deleteSuccess'));
            this.getQueueManageList({ id: this.queueManageForm.envId, type: 'save' });
          });
        })
        .catch(() => {
          this.$message.info(this.$t('logManagement.cancelDelete'));
        });
    },

    /**
     * 保存队列管理
     */
    setQueueManage() {
      postRequest('/api/eda/common/cluster/setAutoScalingQueue', this.queueManageForm).then(() => {
        this.$message.success('队列管理设置成功');
        this.getQueueManageList({ id: this.queueManageForm.envId, type: 'save' });
        this.queueManageDialogVisible = false;
      });
    },

    /**
     * 关闭队列管理
     */
    closeQueueManageDialog() {
      const { envId } = this.queueManageForm;
      this.queueManageForm = {
        name: '',
        rangeId: '',
        templateId: '',
        envId,
        suspendTime: 60,
        resumeTimeout: 120,
        suspendTimeout: 120,
      };
    },

    /**
     * 筛选 模板名称  hostname 名称
     */
    filterQueueManageList(id, list) {
      if (list.length !== 0) {
        return list.filter(item => item.id === id)[0]?.name || id;
      }
    },

    /**
     * 获取集群信息列表
     * 1. 计算分页偏移量
     * 2. 发送请求获取列表数据
     * 3. 更新表格数据
     */
    getList() {
      const offset = this.pageLimit * (this.pageIndex - 1);
      this.tableLoading = true;
      postRequest('/api/eda/common/project/getProjectEnvList', {
        offset,
        limit: this.pageLimit,
      })
        .then((res) => {
          this.tableData = res.list;
          this.tableDataTotal = res.total;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },

    /**
     * 创建集群环境
     * 1. 验证表单
     * 2. 发送创建请求
     * 3. 处理创建结果
     */
    createCode() {
      this.$refs.formLabelAlign.validate((valid) => {
        if (valid) {
          debounce(() => {
            this.createLoading = true;
            if (this.dialogType === 'add') {
              postRequest('/api/eda/common/project/createProjectEnv', this.formLabelAlign)
                .then(() => {
                  Message.success(this.$t('computingCluster.clusterEnv.createSuccess'));
                  this.createLoading = false;
                  this.dialogVisible = false;
                  this.getList();
                })
                .catch(() => {
                  this.createLoading = false;
                });
            } else {
              postRequest('/api/eda/common/project/modifyProjectEnv', this.formLabelAlign)
                .then(() => {
                  Message.success(this.$t('computingCluster.clusterEnv.modifySuccess'));
                  this.createLoading = false;
                  this.dialogVisible = false;
                  this.getList();
                })
                .catch(() => {
                  this.createLoading = false;
                });
            }
          }, 500);
        } else {
          this.$message.warning(this.$t('computingCluster.clusterEnv.fillRequiredParams'));
        }
      });
    },

    /**
     * 编辑集群环境
     * @param {Object} e - 要编辑的环境数据
     * 1. 设置编辑模式
     * 2. 填充表单数据
     * 3. 打开对话框
     */
    editEnv(e) {
      this.dialogType = 'edit';
      this.dialogTitle = this.$t('computingCluster.clusterEnv.editClusterEnv');
      this.formLabelAlign = Object.assign({}, e);
      this.dialogVisible = true;
      this.changeRegion();
    },

    /**
     * 显示集群环境详情
     * @param {Object} item - 要显示的环境数据
     * 1. 设置环境数据
     * 2. 打开详情对话框
     */
    clearEnv(item) {
      this.clusterForm = item;
      this.projectEnvLoading = false;
      this.projectEnvDialogVisible = true;
    },

    /**
     * 分页器页数变化处理
     * @param {number} val - 新的页数
     * 1. 更新当前页数
     * 2. 重新获取列表数据
     */
    onCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },

    /**
     * 每页显示数量变化处理
     * @param {number} val - 新的每页显示数量
     * 1. 更新每页显示数量
     * 2. 重新获取列表数据
     */
    handleSizeChange(val) {
      this.pageLimit = val;
      this.getList();
    },

    /**
     * 创建集群环境
     * 1. 检查是否为QQ登录
     * 2. 验证腾讯云账号是否存在
     * 3. 打开创建对话框或显示AK/SK验证
     */
    createClusterEnv() {
      if (this.loginType === 'qq') {
        postRequest('/api/eda/common/eda/checkProjectTencentAccountExist', {
          isOwner: this.currentProject.isOwner === 1,
        })
          .then(() => {
            this.openDialog();
          })
          .catch((e) => {
            console.log('open dialog error:', e);
            // 管理员isOwner = 1
            if (this.currentProject.isOwner === 1) {
              this.examineAKSKVisible = true;
            }
          });
      } else {
        this.openDialog();
      }
    },

    /**
     * 关闭AK/SK验证对话框
     */
    examineAKSKVisibleFalse() {
      this.examineAKSKVisible = false;
    },

    /**
     * 获取可用区信息
     * 1. 发送请求获取可用区列表
     * 2. 如果是编辑模式，获取子网信息
     */
    getZones() {
      this.zones = [];
      postRequest('/api/eda/common/tencentcloud/describeZones', {
        projectId: this.projectId,
        region: this.formLabelAlign.region,
      }).then((res) => {
        this.zones = res.zoneSet;
        if (this.dialogType === 'edit') {
          this.getSubnet();
        }
      });
    },

    /**
     * 获取子网信息
     * 1. 检查VPC ID和可用区是否已选择
     * 2. 发送请求获取子网列表
     */
    getSubnet() {
      this.subnetList = [];
      if (this.formLabelAlign.vpcId === '') {
        return;
      }
      if (this.formLabelAlign.zone === '') {
        return;
      }
      postRequest('/api/eda/common/tencentcloud/describeSubnetList', {
        projectId: this.projectId,
        region: this.formLabelAlign.region,
        vpcId: this.formLabelAlign.vpcId,
        zone: this.formLabelAlign.zone,
      }).then((res) => {
        this.subnetList = res.subnetSet;
      });
    },

    /**
     * VPC或可用区变化处理
     * 1. 重置子网ID
     * 2. 重置CFS ID
     * 3. 获取子网信息
     */
    changeVpcZone() {
      this.formLabelAlign.subnetId = '';
      this.formLabelAlign.cfsId = '';
      this.subnetList = [];
      this.getSubnet();
    },

    /**
     * 创建VPC
     * 1. 发送创建VPC请求
     * 2. 更新VPC列表
     * 3. 设置新创建的VPC ID
     */
    createVpc() {
      this.createVpcLoading = true;
      postRequest('/api/eda/common/project/createVpc', {
        region: this.formLabelAlign.region,
      })
        .then((res) => {
          this.createVpcLoading = false;
          this.$message.success(this.$t('computingCluster.clusterEnv.createSuccess'));
          this.changeRegion();
          this.formLabelAlign.vpcId = res.vpcId;
          this.formLabelAlign.cfsRegion = '';
          this.formLabelAlign.cfsId = '';
          this.formLabelAlign.securityGroupId = '';
          this.formLabelAlign.subnetId = '';
        })
        .catch(() => {
          this.createVpcLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.table_width {
  width: 100%;
}

// table 背景颜色+padding10px
.table {
  background: #fff;
  padding: 10px;
  // table内容部分下边距和最小高度
  .el-table {
    margin-bottom: 10px;
    min-height: 400px;
  }
}

.spanCls {
  width: 50px;
  line-height: 40px;
}
</style>
